module.exports = __webpack_public_path__ + "static/fv_background-e49d4a2f5a9c69a8e62c1fab0fdf44b8.png";